import React from "react";

const MasterCard = ({ width, height, color }) => {
  return (
    <svg
     

      width="49"
      height="30"
      viewBox="0 0 49 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14.6675" cy="14.6675" r="14.6675" fill="#E72022" />
      <circle cx="33.6655" cy="14.6675" r="14.6675" fill="#F39E21" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.8874 25.9824C26.8883 23.1964 28.7768 19.1478 28.7768 14.6417C28.7768 10.1356 26.8883 6.087 23.8874 3.30106C20.8866 6.087 18.998 10.1356 18.998 14.6417C18.998 19.1478 20.8866 23.1964 23.8874 25.9824Z"
        fill="#E72022"
        fillOpacity="0.5"
      />
    </svg>
  );
};
export default MasterCard;
